module.exports = __webpack_public_path__ + "media/promo/velle/images/recipes/recipe_4-7345a9bef3594a8654f28068a881b7e2.jpg";